import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import $ from 'jquery'
import { v4 as uuidv4 } from 'uuid'
import { encodeRemoteFileName } from '../../redux/media/state'
import { useEffect } from 'react'
import mimeTypes from '../../common/VideoMimeTypes'

const getMimeType = filename => {
  const ext = filename.split('.').pop()
  return mimeTypes.find(item => item.ext === ext)?.mime
}

const DeleteButton = props => {
  const { handleDelete } = props
  return (
    <Button
      className="ms-2 position-absolute thumbnail__delete"
      variant="light"
      size="sm"
      onClick={handleDelete}
      title="Remove">
      <span
        aria-hidden="true"
        className="font-weight-bold">
        &times;
      </span>
    </Button>
  )
}

const Thumbnail = props => {
  const { file, handleDelete } = props
  if (!file) return null
  const src = encodeRemoteFileName(file)
  return (
    <div className="thumbnail bg-secondary d-flex align-items-center justify-content-center img-thumbnail p-3 position-relative">
      <video
        autoplay
        muted
        loop
        id={`video-upload-${file}`}
        style={{ width: '240px' }}>
        <source
          src={src}
          type={getMimeType(file)}
        />
      </video>
      <DeleteButton handleDelete={handleDelete} />
    </div>
  )
}

const Input = props => {
  const { id, name, file, className, disabled, handleChange } = props
  if (file) {
    return null
  }

  let cssClass = 'file-input'
  if (className) {
    cssClass += ' ' + className
  }

  return (
    <div className={cssClass}>
      <input
        id={id}
        type="file"
        disabled={disabled}
        name={name}
        onChange={handleChange}
        accept="video/*"
      />
    </div>
  )
}

export default props => {
  const { image: input, name, className, handleChange: onChange } = props

  const [id, setID] = useState(uuidv4())
  const [file, setFile] = useState(input)
  const [selectedFile, setSelectedFile] = useState(null)
  const [serverError, setServerError] = useState('')
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setFile(input)
  }, [input])

  const handleChange = event => {
    setSelectedFile(event.target.files[0])
    setDisabled(true)
    const data = new FormData()
    data.append('file', event.target.files[0])

    var requestOptions = {
      method: 'POST',
      body: data,
      credentials: 'include'
    }
    var auth = localStorage.getItem('mediaApiToken')
    if (auth) requestOptions.headers = { 'Authentication-Info': auth }

    let url = window.endpoint.media + '/media'

    fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          throw new Error(data.errors[0].detail || data.errors[0].title)
        }
        setFile(data.data.attributes.url)
        setDisabled(false)
        if (onChange) {
          onChange(name, data.data.attributes.url)
        }
      })
      .catch(err => {
        setDisabled(false)
        setServerError(err.message)
        console.log(err.message)
      })
  }

  const handleDelete = () => {
    reset()
    if (onChange) {
      onChange(name, null)
    }
  }

  const reset = () => {
    setFile(null)
    setDisabled(false)
    setSelectedFile(null)
    setServerError(null)

    $('input[type="file"][name="' + name + '"]').val('')
  }

  return (
    <>
      {serverError ? <p className="text-danger">{serverError}</p> : null}
      <Thumbnail
        file={file}
        handleDelete={handleDelete}
      />
      <Input
        id={id}
        name={name}
        file={file}
        className={className}
        disabled={disabled}
        handleChange={handleChange}
      />
    </>
  )
}
